export enum CommonSubjectType {
  CreditNote = 'creditNote',
}
